import { render, staticRenderFns } from "./CatalogFilterDesktop.vue?vue&type=template&id=20841036&scoped=true"
import script from "./CatalogFilterDesktop.vue?vue&type=script&lang=js"
export * from "./CatalogFilterDesktop.vue?vue&type=script&lang=js"
import style0 from "./CatalogFilterDesktop.vue?vue&type=style&index=0&id=20841036&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20841036",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Fcatalog-filter-desktop%2FCatalogFilterDesktop.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports